<template>
  <div class="lowcode-page">
    <a-card>
      <!-- 过滤栏 -->
      <div class="filter-bar">
        <a-form layout="inline">
          <a-form-item label="页面名称">
            <a-input v-model:value="filters.name" placeholder="请输入页面名称" style="width:180px;" />
          </a-form-item>
          <a-form-item label="类型">
            <a-select v-model:value="filters.type" placeholder="请选择类型" style="width:120px;">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="dashboard">仪表盘</a-select-option>
              <a-select-option value="form">表单</a-select-option>
              <a-select-option value="custom">自定义</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="onSearch" style="margin-right:8px;">查询</a-button>
            <a-button @click="onReset">重置</a-button>
          </a-form-item>
        </a-form>
      </div>
      <!-- 操作按钮区 -->
      <div class="action-bar">
        <a-button type="primary" @click="onAdd" style="margin-right:8px;">新建页面</a-button>
        <a-button type="danger" :disabled="!selectedRowKeys.length" @click="onBatchDelete">批量删除</a-button>
      </div>
      <!-- 列表区 -->
      <a-table
        rowKey="id"
        :columns="columns"
        :data-source="dataSource"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        style="margin-top: 16px;"
      >
        <template #emptyText>
          <a-empty description="暂无数据" />
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'action'">
            <a @click="onEdit(record)" style="color:#1677ff; margin-right:8px;">编辑</a>
            <a @click="onDelete(record)" style="color:#ff4d4f;">删除</a>
          </template>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const filters = ref({ name: '', type: '' })
const selectedRowKeys = ref([])
const dataSource = ref([
  {
    id: 1,
    name: '设备监控仪表盘',
    type: '仪表盘',
    creator: 'admin',
    createdAt: '2024-05-01 10:00:00',
    status: '启用'
  },
  {
    id: 2,
    name: '设备登记表单',
    type: '表单',
    creator: '张三',
    createdAt: '2024-05-02 09:30:00',
    status: '停用'
  },
  {
    id: 3,
    name: '自定义页面A',
    type: '自定义',
    creator: '李四',
    createdAt: '2024-05-03 14:20:00',
    status: '启用'
  }
])

const columns = [
  { title: '页面名称', dataIndex: 'name', key: 'name' },
  { title: '类型', dataIndex: 'type', key: 'type' },
  { title: '创建人', dataIndex: 'creator', key: 'creator' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '操作', key: 'action' }
]

function onSearch() {}
function onReset() { filters.value = { name: '', type: '' } }
function onAdd() {
  window.open('http://localhost:9528/__vtj__/#/', '_blank')
}
function onEdit(record: any) {}
function onDelete(record: any) {}
function onBatchDelete() {}
function onSelectChange(keys: any) { selectedRowKeys.value = keys }
</script>

<style scoped>
.lowcode-page {
  padding: 32px;
}
.filter-bar {
  margin-bottom: 16px;
}
.action-bar {
  margin-bottom: 8px;
}
</style> 